import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["display", "cents", "slider"];

  displayChanged(event) {
    const formatted = this.#format(event.target.value);
    event.target.value = formatted;
    this.#syncCents(formatted);
    if (this.hasSliderTarget) this.#syncSlider(formatted);
  }

  sliderChanged() {
    const dollars = parseInt(this.sliderTarget.value);
    const formatted = dollars.toLocaleString();
    this.displayTarget.value = formatted;
    this.#syncCents(formatted);
  }

  #format(value) {
    value = value.replace(/[^\d.]/g, "");
    if (value.length > 0) {
      if (value === ".") {
        value = "0.";
      } else if (value.startsWith("00")) {
        value = "0";
      } else if (value.indexOf(".") !== value.lastIndexOf(".")) {
        value = value.slice(0, value.lastIndexOf("."));
      } else if (value.indexOf(".") !== -1 && value.length - value.indexOf(".") > 3) {
        value = value.slice(0, value.indexOf(".") + 3);
      }
      let parts = value.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      value = parts.join(".");
    }
    return value;
  }

  #syncCents(formatted) {
    const raw = formatted.replace(/[^\d.]/g, "");
    const cents = Math.round(parseFloat(raw) * 100);
    this.centsTarget.value = raw === "" || Number.isNaN(cents) ? "" : cents;
  }

  #syncSlider(formatted) {
    clearTimeout(this._sliderTimer);
    this._sliderTimer = setTimeout(() => {
      const raw = formatted.replace(/[^\d.]/g, "");
      const dollars = Math.round(parseFloat(raw) || 0);
      const min = parseInt(this.sliderTarget.min);
      const max = parseInt(this.sliderTarget.max);
      this.sliderTarget.value = Math.min(Math.max(dollars, min), max);
    }, 300);
  }
}
